export function formatDMY(d: string) {
    const date = d.split(' ')[0];
    const [day, month, year] = date.split('.');
    const dateObject = new Date(+year, +month - 1, +day);

    return `${(`0${dateObject.getMonth() + 1}`).slice(-2)}/${
        (`0${dateObject.getDate()}`).slice(-2)}/${
        (`000${dateObject.getFullYear()}`).slice(-4)}`;
}
